/* eslint-disable react/require-default-props */
import React from 'react';
import { IssueStatusEnum } from '../../types';
import ManagerNote from './ManagerNote';
import IssueLayout from './IssueLayout';
import './styles.scss';
export default function TimingAuditFindingCard({ issue, defaultExpanded, onToggle, onUpdateIssue, onUndoAction, readOnly = false }) {
    var _a;
    const status = issue.status || IssueStatusEnum.Detected;
    // Handler functions for issue actions
    const handleSuggestCorrection = () => {
        onUpdateIssue(issue.id, status, true);
    };
    const handleDismissIssue = () => {
        onUpdateIssue(issue.id, IssueStatusEnum.DismissedByBackOffice, false);
    };
    const handleNoteChange = (note) => {
        onUpdateIssue(issue.id, status, issue.markedForSuggestion, note);
    };
    return (React.createElement(IssueLayout, { issueType: "timing_audit", status: status, defaultExpanded: defaultExpanded, onToggle: onToggle, onSuggestCorrection: handleSuggestCorrection, onDismissIssue: handleDismissIssue, onUndoAction: onUndoAction, readOnly: readOnly, statusChanges: issue.statusChanges, markedForSuggestion: issue.markedForSuggestion },
        React.createElement(React.Fragment, null,
            React.createElement("div", null,
                React.createElement("p", null, issue.issueData.summary),
                React.createElement("p", null,
                    "Suspicion Level: ",
                    issue.issueData.suspicionLevel)),
            issue.markedForSuggestion && (!readOnly || ((_a = issue.managerNote) === null || _a === void 0 ? void 0 : _a.trim())) && (React.createElement("div", { className: "issue-card__body" },
                React.createElement(ManagerNote, { note: issue.managerNote || '', onNoteChange: handleNoteChange, disabled: readOnly }))))));
}
